module.exports = __webpack_public_path__ + "static/blocks-d659948e82330c7a035925155c10387f.svg";